module.exports = __webpack_public_path__ + "static/media/Grilled_neck_tail.5e0b3606.png";